import type { ReactNode } from 'react'

interface FieldProps {
  label: string
  children: ReactNode
}

export function Field({ label, children }: FieldProps) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="tracked-caps text-[10px] text-muted">{label}</span>
      {children}
    </label>
  )
}
